export default __webpack_public_path__ + "static/media/welcome.39fc7cb5.png";